import { PortfolioLookupResolveService } from './shared/portfolio-lookup-resolve.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PortfolioService } from './shared/services/portfolio.service';

import { PortfoliosRoutingModule } from './portfolios-routing.module';
import { PortfolioListComponent } from './portfolio-list/portfolio-list.component';
import { PortfolioShellComponent } from './portfolio-shell/portfolio-shell.component';
import { PortfolioAddComponent } from './portfolio-add/portfolio-add.component';
import { PortfolioViewComponent } from './portfolio-view/portfolio-view.component';
import { PortfolioCustomerDetailsComponent } from './portfolio-customer-details/portfolio-customer-details.component';
import { PortfolioEditNameComponent } from './portfolio-edit-name/portfolio-edit-name.component';
import { PortfolioEditAccountManagerComponent } from './portfolio-edit-account-manager/portfolio-edit-account-manager.component';
import { PortfolioViewHistoryComponent } from './portfolio-view-history/portfolio-view-history.component';
import { PortfolioCustomerMoveComponent } from './portfolio-customer-move/portfolio-customer-move.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { PortfolioAddSalesAssistantComponent } from './portfolio-add-sales-assistant/portfolio-add-sales-assistant.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PortfoliosRoutingModule,
    MultiSelectModule,
    AngularSvgIconModule,
    DatePicker,
  ],
  providers: [PortfolioService, PortfolioLookupResolveService],
  declarations: [
    PortfolioListComponent,
    PortfolioShellComponent,
    PortfolioAddComponent,
    PortfolioViewComponent,
    PortfolioCustomerDetailsComponent,
    PortfolioEditNameComponent,
    PortfolioEditAccountManagerComponent,
    PortfolioViewHistoryComponent,
    PortfolioCustomerMoveComponent,
    PortfolioAddSalesAssistantComponent,
  ],
})
export class PortfoliosModule {}
